import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact'
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const ComunicadosPublicados = (props) => {

	const [comunicados, setComunicados] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetch('/z_comunicados')
		.then((res) => res.json())
		.then((res) => {
			console.log(res);
			if(res.status === 1){
				setComunicados(res.result)
			}else{
				console.log('ERROR')
			}
		})
		.catch((err) => {
			console.log('ERROR: '+err)
		})
		.finally(() => {
			setLoading(false)
		})
	}, []);

	const cabecera = [
        { Header: <b>Id</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'80', show:false },
        { Header: <b>Título</b>, accessor: 'TITULO', style: { textAlign: 'left'}, width:'auto', editable:false , show:true},
        { Header: <b>Descripción</b>, accessor: 'DESCRIPCION', style: { textAlign: 'left'}, width:'auto', editable:false , show:true},
		{ Header: <b>Estatus</b>, accessor: 'ESTATUS', style: { textAlign: 'center'}, width:'120', editable:false , show:true},
        { Header: <b>Fecha informativa</b>, accessor: 'FECHA_INFORMATIVA', style: { textAlign: 'center'}, width:'150', editable:false , show:true},
        { Header: <b>Fecha de publicación</b>, accessor: 'FECHA_PUBLICACION', style: { textAlign: 'center'}, width:'200', editable:false , show:true}
    ];

	const actualizar=(dato)=>props.history.push('/comunicados/editar/'+dato.ID)
	const agregar=()=>props.history.push('/comunicados/agregar')
	const eliminar=(dato)=>{
		fetch('/p_comunicados',{ method: 'DELETE', body: JSON.stringify({id: dato.ID}), headers: { 'Content-Type': 'application/json' }})
		.then( res => res.json() )
		.then( res => {
			if(res.status === 'OK'){
				setComunicados(comunicados.filter(x=>x.ID!==dato.ID))
				toast.success("Se eliminó el registro", { position: toast.POSITION.BOTTOM_RIGHT })
			}
			else
				toast.warn("No se pudo borrar el registro", { position: toast.POSITION.BOTTOM_RIGHT })
		})
		.catch( (err) => {
			toast.error("Ha ocurrido un error", { position: toast.POSITION.BOTTOM_RIGHT })
		})
	}

	return (
	<Fragment>
		<Breadcrumb parent="Comunicados" title="Publicados"/>
		<div className="card">
			<div className="container-fluid">
			{
				loading ?
				<div className="d-flex justify-content-center align-items-center">
					<div className="loader-box mr-4">
						<div className="loader">
							<div className="line bg-warning"></div>
							<div className="line bg-warning"></div>
							<div className="line bg-warning"></div>
							<div className="line bg-warning"></div>
						</div>
					</div>
					<h5 className="text-uppercase">Cargando...</h5>
				</div>
				:
				<div className="row">
					<div className="col-sm-12 mt-3">
						<Tablereact
                            myData={comunicados}
                            cabecera={cabecera}
                            pageSize={10}
                            paginacion={true}
                            buscador='Buscar Comunicado'
                            eliminar_actualizar={{eliminar,actualizar}}
                            boton={{text:'Agregar Comunicado',function:agregar}}
                        />
					</div>
				</div>
			}
			</div>
		</div>
	</Fragment>
	);
}
 
export default ComunicadosPublicados;